export const MAPP_PROJECT_STEP_HISTORY_CONSTANT = {
  CREATE_START: 'LI/MAPP/PROJECT-STEP-HISTORY/create/requested',
  CREATE_FAILED: 'LI/MAPP/PROJECT-STEP-HISTORY/create/failed',
  CREATE_SUCCESS: 'LI/MAPP/PROJECT-STEP-HISTORY/create/success',

  RESET_ALL: 'LI/MAPP/PROJECT-STEP-HISTORY/reset-state',
  RESET_STATUS: 'LI/MAPP/PROJECT-STEP-HISTORY/reset-status',
};
